import { ChangeDetectionStrategy, Component, inject, input, OnInit, signal } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { NODE_EDIT_TAB_COMPONENT, NodeEditTab, SelectedNodeForEdit } from 'src/app/shared/flow-chart/flow-chart.model';
import { JsCodeNodeData } from '../../../node-edit.type';
import { EditorComponent } from 'ngx-monaco-editor-v2';

@Component({
  selector: 'edit-js-code',
  imports: [
    ReactiveFormsModule,
    TranslatePipe,
    EditorComponent,
  ],
  templateUrl: './edit-js-code.component.html',
  styleUrl: './edit-js-code.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NODE_EDIT_TAB_COMPONENT,
      useExisting: EditJsCodeComponent,
    },
  ],
})
export class EditJsCodeComponent implements OnInit, NodeEditTab {
  public selectedNodeForEdit = input<SelectedNodeForEdit<JsCodeNodeData>>();
  public disableForm = input<boolean>(false);

  private readonly fb = inject(UntypedFormBuilder);
  private readonly translateService = inject(TranslateService);

  protected editorOptions = signal({ language: 'javascript', automaticLayout: true });

  public form: UntypedFormGroup = this.fb.group({
    name: [this.translateService.instant('FLOW_CHART.NODES.JS_CODE.NAME'), [Validators.required]],
    code: [''],
  })

  public ngOnInit(): void {
    if (this.disableForm()) {
      this.form.disable();
    }

    if (this.selectedNodeForEdit()?.data?.name) {
      this.form.setValue({
        name: this.selectedNodeForEdit().data.name,
        code: this.selectedNodeForEdit().data.code,
      })
    }
  }

  public onInit(editor) {
    setTimeout(() => {
      editor.getAction('editor.action.formatDocument')
        .run();
    }, 500);
  }
}
